import React, { Component } from 'react';
import ImageModalContainer from '../image-display/ImageModalContainer';
import TestRoute from '../TestRoute';

class Modal extends Component {

  constructor(props) {
    super(props);
   	this.onBackdropClick = this.onBackdropClick.bind(this);
  }

  ModalComponent = TestRoute;
  modalComponentsLibrary = {
    'ImageModalContainer': ImageModalContainer
  }

  onBackdropClick(e) {
  	if (e.target === e.currentTarget) {
        e.preventDefault();
        e.stopPropagation();
        this.props.dispatchCloseModal();
    }
  }

  componentWillReceiveProps(nextProps) {
  	if (nextProps.showModal && !this.props.showModal) {
      //populate modal component
      this.ModalComponent = this.modalComponentsLibrary[nextProps.modalComponentProps.modalComponent];

  		document.body.classList.add('modal-open');
  		document.getElementById('root').classList.add('modal-open');
  		this.modalEl.style.display = 'block';
  		this.modalEl.classList.add('in');
  	}
  	if (!nextProps.showModal && this.props.showModal) {
  		document.body.classList.remove('modal-open');
  		document.getElementById('root').classList.remove('modal-open');		this.modalEl.classList.remove('in');
  		setTimeout(() => {
  			this.modalEl.style.display = 'none';
  		}, 600)
  	}
  }

  render() {
    return (      
        <div ref={(el) => { this.modalEl = el; }} onClick={this.onBackdropClick} className="modal fade" tabIndex="-1" role="dialog" style={{zIndex: '1050'}}>
    		<div className="modal-dialog">
        		<div className="modal-content">
              <this.ModalComponent modalComponentProps={this.props.modalComponentProps}></this.ModalComponent>
        		</div>
    		</div>
		</div>
    );
  }
}

export default Modal;



/** WEBPACK FOOTER **
 ** ./src/modal/Modal.js
 **/